<div class="access-denied-container">
    <h1>Access Denied</h1>
    <p>You do not have permission to view this page.</p>
    <a [routerLink]="dashboardUrl">Go to Dashboard</a>
</div>